import React from 'react'
import Inputsection from './Components/SearchSection/inputsection'
import Moviecards from './Components/MovieCards/moviecards'
import './App.css';

function App() {
  return (
    <div className="App">
     
    <Moviecards/>
    </div>
  );
}

export default App;
